import PropTypes from "prop-types"
import React from "react"

import Input from "@atoms/Input/Input"

const RangeInput = ({ onInputChange, value, unit = "€/kk" }) => (
  <div className="flex justify-center items-center gap-2">
    <div className="relative w-44">
      <Input
        type="number"
        placeholder="Min"
        name="min"
        id="min-range"
        additionalClassName="pr-7 py-3.5"
        onChange={onInputChange}
        value={value.min}
      />
      <span className="absolute top-1/2 transform -translate-y-1/2 right-2.5 text-sm font-inter">
        {unit}
      </span>
    </div>
    <span className="text-sm">-</span>
    <div className="relative w-44">
      <Input
        type="number"
        placeholder="Max"
        name="max"
        id="max-range"
        additionalClassName="pr-7 py-3.5"
        onChange={onInputChange}
        value={value.max}
      />
      <span className="absolute top-1/2 transform -translate-y-1/2 right-2.5 text-sm font-inter">
        {unit}
      </span>
    </div>
  </div>
)

RangeInput.propTypes = {
  onInputChange: PropTypes.func,
  value: PropTypes.shape({
    min: PropTypes.string.isRequired,
    max: PropTypes.string.isRequired,
  }),
  unit: PropTypes.string,
}

export default RangeInput
